import React, {
    useEffect
} from 'react';


import {

    FondoModalInvitacion,
    ModalInvitacion,

    EncabezadoModalInvitacion,
    TituloModalInvitacion,
    BotonCerrarModalInvitacion,

    TextoModalInvitacion,
    BloqueEmailInvitacion,
    EmailInvitacion,

    AvisoModalInvitacion,

    ErrorModalInvitacion,

    AccionesModalInvitacion,
    BotonCancelarInvitacion,
    BotonConfirmarInvitacion

} from '../../Css/StyledInvitarPaciente';


const ModalInvitarPaciente = ({

    abierto,

    email,

    enviando = false,

    error = '',

    onCerrar,

    onConfirmar

}) => {


    /*
    ====================================
    CERRAR CON ESCAPE
    ====================================
    */

    useEffect(
        () => {

            if (
                !abierto
            ) {

                return undefined;

            }


            const manejarEscape =
                event => {

                    if (
                        event.key === 'Escape' &&
                        !enviando
                    ) {

                        onCerrar();

                    }

                };


            document.addEventListener(
                'keydown',
                manejarEscape
            );


            /*
            Evitamos scroll del fondo mientras
            el modal está abierto.
            */

            const overflowAnterior =
                document.body.style.overflow;


            document.body.style.overflow =
                'hidden';


            return () => {

                document.removeEventListener(
                    'keydown',
                    manejarEscape
                );


                document.body.style.overflow =
                    overflowAnterior;

            };

        },
        [
            abierto,
            enviando,
            onCerrar
        ]
    );


    if (
        !abierto
    ) {

        return null;

    }


    return (

        <FondoModalInvitacion

            onMouseDown={
                event => {

                    /*
                    Solo cerramos si se hace click
                    realmente sobre el fondo.

                    Clicks dentro del modal no lo
                    cierran.
                    */

                    if (
                        event.target ===
                        event.currentTarget &&
                        !enviando
                    ) {

                        onCerrar();

                    }

                }
            }

        >


            <ModalInvitacion

                role="dialog"

                aria-modal="true"

                aria-labelledby="titulo-invitar-paciente"

            >


                <EncabezadoModalInvitacion>


                    <TituloModalInvitacion

                        id="titulo-invitar-paciente"

                    >

                        Invitar paciente a YÖGEN

                    </TituloModalInvitacion>


                    <BotonCerrarModalInvitacion

                        type="button"

                        disabled={
                            enviando
                        }

                        aria-label="Cerrar"

                        onClick={
                            onCerrar
                        }

                    >

                        ×

                    </BotonCerrarModalInvitacion>


                </EncabezadoModalInvitacion>


                <TextoModalInvitacion>

                    Se enviará un enlace al email
                    del paciente para completar
                    la creación de su usuario en
                    YÖGEN.

                </TextoModalInvitacion>


                <BloqueEmailInvitacion>

                    El enlace será enviado a:

                    <EmailInvitacion>

                        {email}

                    </EmailInvitacion>

                </BloqueEmailInvitacion>


                <TextoModalInvitacion>

                    Al abrir el enlace, la familia
                    podrá revisar y corregir los
                    datos principales del paciente
                    y del Tutor 1, y crear la
                    contraseña del paciente.

                </TextoModalInvitacion>


                <AvisoModalInvitacion>

                    <strong>
                        Importante:
                    </strong>

                    {' '}

                    cada email debe corresponder
                    a una única persona y rol
                    dentro de YÖGEN. El email del
                    paciente no puede coincidir
                    con el del profesional ni con
                    el de sus tutores.

                </AvisoModalInvitacion>


                <TextoModalInvitacion>

                    El enlace de invitación tendrá
                    una validez de 48 horas.

                </TextoModalInvitacion>


                {
                    error && (

                        <ErrorModalInvitacion>

                            {error}

                        </ErrorModalInvitacion>

                    )
                }


                <AccionesModalInvitacion>


                    <BotonCancelarInvitacion

                        type="button"

                        disabled={
                            enviando
                        }

                        onClick={
                            onCerrar
                        }

                    >

                        Cancelar

                    </BotonCancelarInvitacion>


                    <BotonConfirmarInvitacion

                        type="button"

                        disabled={
                            enviando
                        }

                        onClick={
                            onConfirmar
                        }

                    >

                        {
                            enviando
                                ?
                                'Enviando...'
                                :
                                'Enviar invitación'
                        }

                    </BotonConfirmarInvitacion>


                </AccionesModalInvitacion>


            </ModalInvitacion>


        </FondoModalInvitacion>

    );

};


export default ModalInvitarPaciente;